
import React from 'react';

interface ProcessStep {
  step: string;
  title: string;
  description: string;
  icon: React.ElementType;
}

interface ProcessStepsProps {
  title: string;
  subtitle: string;
  steps: ProcessStep[];
}

const ProcessSteps = ({ title, subtitle, steps }: ProcessStepsProps) => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              {subtitle}
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center group">
                <div className="bg-blue-600 text-white p-6 w-20 h-20 mx-auto mb-6 flex items-center justify-center text-2xl font-bold group-hover:bg-pink-500 transition-colors duration-300">
                  {step.step}
                </div>
                <step.icon className="text-blue-600 mx-auto mb-4 group-hover:text-pink-500 transition-colors duration-300" size={32} />
                <h3 className="text-lg font-semibold text-navy-900 mb-3">{step.title}</h3>
                <p className="text-navy-600 font-light text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
